import React from 'react';
// src/components/ui/Spinner.tsx
// Small inline/in-button spinner. Per STYLEGUIDE, prefer <Skeleton> for
// full-surface loading; reserve the spinner for in-button and short inline waits.

const sizes: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Optional visible label shown beside the spinner. */
  label?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className = '', label }) => (
  <span role="status" className={`inline-flex items-center gap-2 ${className}`}>
    <span
      className={`inline-block ${sizes[size]} animate-spin rounded-full border-ink-200 border-t-navy-600`}
      aria-hidden="true"
    />
    {label ? <span className="text-body-sm text-ink-500">{label}</span> : <span className="sr-only">Loading…</span>}
  </span>
);

export default Spinner;
